var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-container-widget',{staticClass:"d-flex",attrs:{"id":"mentimeter","title":_vm.widgetName,"app-id":98,"stretch":""}},[_c('iframe',{staticStyle:{"border":"none","height":"100%","border-radius":"5px"},attrs:{"src":_vm.mentiUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }